import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppState } from "redux/store";
import CustomerUpdateHeader from "./customerUpdateHeader";
import CustomerUpdate from "./customerUpdate";
import { getCustomerDetail } from "redux/actions";

const CustomerCareUpdateIndex: React.FC = () => {
  const dispatch = useDispatch();

  const { pageID } = useParams<{ pageID?: string }>();
  console.log(pageID);


  const { currentCustomer } = useSelector<AppState, AppState["customerMaster"]>(
    ({ customerMaster }) => customerMaster
  );

  useEffect(() => {
    dispatch({ type: "RESET_Customer_DATA" });
    if (pageID !== undefined) {
      dispatch(getCustomerDetail(pageID));
    }
  }, [dispatch, pageID]);

  return (
    <>
      {currentCustomer ? (
        <AppAnimate animation="transition.slideUpIn" delay={200}>
          <AppCard>
            <CustomerUpdateHeader customer={currentCustomer} />

            <AppGridContainer>
              <CustomerUpdate Customer={currentCustomer} />
            </AppGridContainer>
          </AppCard>
        </AppAnimate>
      ) : null}
      <AppInfoView />
    </>
  );
};

export default CustomerCareUpdateIndex;
